import { StateCreator } from 'zustand'
import { InviteLinksState } from '../state'
import {
    DetalizationOptionType,
    UsersSortOptionType,
    typedUsersSortOptions,
    typedDetalizationSortOptions,
    InviteLinksChartOptionType,
    SubscriberStatusSortOptionType,
    typedSubscriberStatusSortOptions,
    LineDateSortOptionType,
} from '../../constants'
import { SelectedGroupsType } from '../types'
import { InviteLinkWithAnalyticsType } from '@/shared/api'

export interface InviteLinksGroupSlice {
    groupChartIsExpanded: boolean
    selectedChartMetricGroup: InviteLinksChartOptionType
    detalizationSortGroup: DetalizationOptionType
    usersSortGroup: UsersSortOptionType
    subscriberStatusSortGroup: SubscriberStatusSortOptionType
    startDateGroup: string
    endDateGroup: string
    lineDateGroup: LineDateSortOptionType | null
    selectedGroups: SelectedGroupsType
    toggleGroupChartIsExpanded: () => void
    setSelectedChartMetricGroup: (value: InviteLinksChartOptionType) => void
    setLineDateGroup: (value: LineDateSortOptionType | null) => void
    setStartDateGroup: (value: string) => void
    setEndDateGroup: (value: string) => void
    setDetalizationSortGroup: (value: DetalizationOptionType) => void
    setUsersSortGroup: (value: UsersSortOptionType) => void
    setSubscriberStatusSortGroup: (
        value: SubscriberStatusSortOptionType
    ) => void
    toggleSelectedGroup: (channelId: number, groupId: number) => void
    clearSelectedGroupsByChannel: (channelId: number) => void
    movedGroups: { groupId: number; inviteLinks: InviteLinkWithAnalyticsType[] }[];
    setMovedGroups: (groups: { groupId: number; inviteLinks: InviteLinkWithAnalyticsType[] }[]) => void;
    clearMovedGroups: () => void;
    addMovedInviteLinksToGroup: (groupId: number, inviteLinks: InviteLinkWithAnalyticsType[]) => void;
    removeMovedInviteLinksFromGroup: (groupId: number, inviteLinks: InviteLinkWithAnalyticsType[]) => void;
}

export const createInviteLinksGroupSlice: StateCreator<
    InviteLinksState,
    [],
    [],
    InviteLinksGroupSlice
> = (set) => ({
    groupChartIsExpanded: false,
    detalizationSortGroup: typedDetalizationSortOptions[0],
    usersSortGroup: typedUsersSortOptions[0],
    subscriberStatusSortGroup: typedSubscriberStatusSortOptions[0],
    selectedGroups: {},
    startDateGroup: '',
    endDateGroup: '',
    lineDateGroup: null,
    selectedChartMetricGroup: { value: 'subscribedCount', label: 'Вступлений' },

    toggleGroupChartIsExpanded: () =>
        set((state) => ({ groupChartIsExpanded: !state.groupChartIsExpanded })),
    setSelectedChartMetricGroup: (value) =>
        set({ selectedChartMetricGroup: value }),
    setLineDateGroup: (value) => set({ lineDateGroup: value }),
    setStartDateGroup: (value) => set({ startDateGroup: value }),
    setEndDateGroup: (value) => set({ endDateGroup: value }),
    setDetalizationSortGroup: (value) => set({ detalizationSortGroup: value }),
    setUsersSortGroup: (value) => set({ usersSortGroup: value }),
    setSubscriberStatusSortGroup: (value) =>
        set({ subscriberStatusSortGroup: value }),

    toggleSelectedGroup: (channelId: number, groupId: number) => {
        set((state) => {
            let selected = state.selectedGroups[channelId] || []
            if (selected.includes(groupId)) {
                selected = selected.filter(
                    (id) => id !== groupId
                )
            } else {
                selected = [...selected, groupId]
            }
            return {
                selectedGroups: {
                    ...state.selectedGroups,
                    [channelId]: selected,
                },
            }
        })
    },
    clearSelectedGroupsByChannel: (channelId: number) => {
        set((state) => ({
            selectedGroups: {
                ...state.selectedGroups,
                [channelId]: [],
            },
        }))
    },
    movedGroups: [],
    setMovedGroups: (groups) => set({ movedGroups: groups }),
    clearMovedGroups: () => set({ movedGroups: [] }),
    addMovedInviteLinksToGroup: (groupId, inviteLinks) =>
        set((state) => {
            const groupIndex = state.movedGroups.findIndex(
                (group) => group.groupId === groupId
            );
            if (groupIndex !== -1) {
                const updatedGroups = [...state.movedGroups];
                updatedGroups[groupIndex].inviteLinks = [
                    ...new Set([
                        ...updatedGroups[groupIndex].inviteLinks,
                        ...inviteLinks,
                    ]),
                ];
                return { movedGroups: updatedGroups };
            } else {
                return {
                    movedGroups: [
                        ...state.movedGroups,
                        { groupId, inviteLinks: inviteLinks },
                    ],
                };
            }
        }),
    removeMovedInviteLinksFromGroup: (groupId, inviteLinksToRemove) =>
        set((state) => {
            const groupIndex = state.movedGroups.findIndex(
                (group) => group.groupId === groupId
            );
            if (groupIndex !== -1) {
                const updatedGroups = [...state.movedGroups];
                updatedGroups[groupIndex].inviteLinks =
                    updatedGroups[groupIndex].inviteLinks.filter(
                        (link) =>
                            !inviteLinksToRemove.some(
                                (removedLink) =>
                                    removedLink.invite_link_id === link.invite_link_id
                            )
                    );
                return { movedGroups: updatedGroups };
            }
            return state;
        }),
})
